import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import {
    SessionAuthenticationEventDTO,
    SessionAuthenticationEventType,
} from '../../../core/models/dto/session-authentication-event.dto';
import { SessionAuthenticationLevel } from '@sb-tools/typescript/enums/session-authentication-level.enum';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';

@Component({
    selector: 'app-session-authentication-event',
    templateUrl: './session-authentication-event.component.html',
    styleUrls: ['./session-authentication-event.component.scss'],
    imports: [DatePipe, TranslateModule],
})
export class SessionAuthenticationEventComponent {
    @Input() event: SessionAuthenticationEventDTO | ThreadElementDTO;

    readonly eventType = SessionAuthenticationEventType;

    constructor(private translateService: TranslateService) {}

    get levelLabel(): string {
        switch (Number(this.event?.level)) {
            case SessionAuthenticationLevel.pinOrBiometrics:
                return `${this.translateService.instant('PIN or biometrics')} (2)`;
            case SessionAuthenticationLevel.bankIdSubstantial:
                return `${this.translateService.instant('BankID Substantial (OTP)')} (8)`;
            case SessionAuthenticationLevel.bankIdHigh:
                return `${this.translateService.instant('BankID High (OTP + password)')} (10)`;
            default:
                return `${this.translateService.instant('Not authenticated')} (0)`;
        }
    }
}
